let sidebarDrawer = document.getElementById("site-filters");
const refineMenuToggle = document.querySelectorAll(".refine-menu-toggle");
const refineMenu = document.getElementById("refine-menu");
let allProductsLink = sidebarDrawer.querySelector("#Filter-All");
let allProductsUrl = document.URL;
const productGrid = document.querySelector("#CollectionProductGrid");
const facetsOverlay = document.querySelector("#site-filters .facets-overlay");

function hasFilterParams(element) {
	let params = new URLSearchParams(document.location.search);
	const product_type = params.get("filter.p.product_type");
	if (product_type) {
		element?.setAttribute("data-has-filters", "true");
		return;
	}
	element?.setAttribute("data-has-filters", "false");
}

function setAllProductsLink(url) {
	allProductsLink?.setAttribute("href", url);
}

function removeQueryParam(param) {
	const urlObj = new URL(document.URL);
	const params = new URLSearchParams(urlObj.search);
	const values = params.getAll(param);
	if (values.length >= 1) {
		params.delete(param);
		urlObj.search = params.toString();
		return urlObj.toString();
	} else {
		return document.URL;
	}
}

function allProductsNavigate(url) {
	window.location.assign(url);
}

window.addEventListener("load", function () {
	hasFilterParams(sidebarDrawer);
	allProductsUrl = removeQueryParam("filter.p.product_type");
	setAllProductsLink(allProductsUrl);
});

Array.from(refineMenuToggle).map((toggle) => {
	toggle.addEventListener("click", (e) => {
		e.preventDefault();
		if (refineMenu.getAttribute("aria-expanded") === "true") {
			refineMenu?.setAttribute("aria-expanded", "false");
			facetsOverlay.classList.remove("active");
			return;
		}
		refineMenu?.setAttribute("aria-expanded", "true");
		facetsOverlay.classList.add("active");
	});
});

// Create a new MutationObserver
const observer = new MutationObserver(function (mutations) {
	sidebarDrawer = document.getElementById("site-filters");
	hasFilterParams(sidebarDrawer);
	allProductsUrl = removeQueryParam("filter.p.product_type");
	setAllProductsLink(allProductsUrl);
	let allProductsLink = document.querySelector("#Filter-All");
	allProductsLink?.addEventListener("click", (e) => {
		e.preventDefault();
		allProductsNavigate(allProductsUrl);
	});
});

const config = { attributes: true, childList: true, characterData: true };
observer.observe(productGrid, config);
